import { useEffect, useState } from "react";

export const organizationCalendarRevisionKey = (id: number) =>
  `flowenti/organization-calendar-revision/${id}`;

export const publishOrganizationCalendarRevision = (id: number, revision: number) =>
  localStorage.setItem(organizationCalendarRevisionKey(id), String(revision));

const readRevision = (id: number) =>
  Number(localStorage.getItem(organizationCalendarRevisionKey(id)) || 0);

const useOrganizationCalendarRevision = (id: number | null | undefined) => {
  const [revision, setRevision] = useState(() => id ? readRevision(id) : 0);

  useEffect(() => {
    if (!id) return;

    setRevision(readRevision(id));
    const onStorage = (event: StorageEvent) => {
      if (event.key === organizationCalendarRevisionKey(id)) {
        setRevision(Number(event.newValue || 0));
      }
    };
    window.addEventListener("storage", onStorage);
    return () => window.removeEventListener("storage", onStorage);
  }, [id]);

  return revision;
};

export default useOrganizationCalendarRevision;
